module.exports = ".alertWrapper {\n  -webkit-transition: all 2s ease-in-out 0s;\n  transition: all 2s ease-in-out 0s;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  z-index: 99999; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/alert/alert.component.scss
// module id = ./src/app/common/alert/alert.component.scss
// module chunks = main